import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { PuzzleHelpDialogInjectableInterface } from '../../shared-module/puzzle-help-dialog/puzzle-help-dialog-injectable.interface';
import { HelperFunctionsService } from '../../shared-module/helpers/helper-functions.service';

@Component({
  selector: 'lib-app-word-guess-help',
  templateUrl: './word-guess-help.component.html',
  styleUrls: ['./word-guess-help.component.scss'],
  standalone: true,
  imports: [CommonModule, IonText, TranslateModule],
})
export class WordGuessHelpComponent implements PuzzleHelpDialogInjectableInterface {
  data: { translationKey: 'string' };
  isMobile: boolean;

  constructor(private helperFunctions: HelperFunctionsService) {
    this.isMobile = helperFunctions.isMobileDevice();
  }

  setData(data: any): void {
    this.data = data;
  }
}
